import React, {InputHTMLAttributes, ReactNode} from 'react'
import {FieldValues, FieldErrors} from 'react-hook-form'
import {ErrorMessage} from '@hookform/error-message'
import {KTSVG} from '../KTSVG'
import {KTText} from '../KTText'

interface Props
 extends InputHTMLAttributes<HTMLInputElement> {
 label?: string
 type: string
 id?: string
 name: string
 className?: string
 countryCode?: string | ReactNode
 countryBoxClass?: string
 wrapperClassName?: string
 inputWrapperClassName?: string
 labelClassName?: string
 errorIconClassName?: string
 iconPath?: string
 showIcon?: boolean
 helperTextClass?: string
 helperText?: string
 register?: FieldValues
 errors?: FieldErrors | undefined
}

const PhoneNoField = ({
 label,
 className,
 showIcon = true,
 wrapperClassName,
 iconPath,
 labelClassName,
 countryBoxClass,
 errorIconClassName,
 name,
 required,
 countryCode,
 type,
 id,
 onChange,
 onBlur,
 disabled = false,
 readOnly = false,
 step,
 autoComplete = 'off',
 value,
 maxLength,
 minLength,
 min,
 max,
 autoFocus,
 register,
 placeholder,
 helperTextClass,
 inputWrapperClassName,
 helperText,
 errors,
}: Props) => {
 return (
  <>
   <div
    className={`${wrapperClassName} ${
     errors?.[name] && 'border-[#CC293F]'
    } form-field-wrapper relative flex items-stretch rounded-lg border border-solid border-[#E6EBF0] bg-white focus-within:border-[#000000]`}
   >
    <div
     className={`${countryBoxClass} bg-[#E6EBF0] rounded-l-lg py-3 px-4 flex items-center text-[#33393D] text-lg font-medium`}
    >
     {countryCode}
    </div>
    <div
     className={`${inputWrapperClassName} ${
      disabled && '!bg-[#F5F8FA]'
     } rounded-r-lg form-field-wrapper py-2 px-4 relative bg-white focus-within:border-[#000000]`}
    >
     {label && (
      <label
       htmlFor={id}
       className={`input-label ${labelClassName} relative pb-1 text-[#4E83E4] text-xs font-medium`}
      >
       {label}
       {required && (
        <span className='required-field pl-[2px]'>*</span>
       )}
      </label>
     )}
     <input
      type={type}
      step={step}
      name={name}
      id={id ?? name}
      className={`form-input ${className} relative text-lg font-medium text-[#33393D] !disabled:bg-blue-300 relative !disabled:text-[#33393D] pr-6 block w-full`}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      readOnly={readOnly}
      value={value}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      minLength={minLength}
      maxLength={maxLength}
      min={min}
      max={max}
      {...register}
     />
    </div>
    {((errors?.[name] && showIcon) ?? iconPath) && (
     <KTSVG
      path={`${iconPath ?? '/media/icons/icon_error.svg'}`}
      svgClassName={`${errorIconClassName} absolute bottom-[10px] z-11 right-[10px]`}
     />
    )}
   </div>
   {helperText && !errors?.[name] && (
    <KTText className={helperTextClass}>
     {helperText}
    </KTText>
   )}
   {errors && (
    <ErrorMessage
     errors={errors}
     name={name}
     render={({message}) => (
      <p className='error-msg error-cls'>{message}</p>
     )}
    />
   )}
  </>
 )
}

export {PhoneNoField}
